import linkToRecord from './linkToRecord';
export default (function (redirectTo, basePath, id, data) {
    if (typeof redirectTo === 'function') {
        return redirectTo(basePath, id, data);
    }
    switch (redirectTo) {
        case 'list':
            return basePath;
        case 'create':
            return basePath + "/create";
        case 'edit':
            return linkToRecord(basePath, id);
        case 'show':
            return linkToRecord(basePath, id) + "/show";
        default:
            return redirectTo;
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-admin/node_modules/ra-core/esm/util/resolveRedirectTo.js
// module id = 486
// module chunks = 0